// this file added by Bearer Web Developer - change map api
import React from "react";
import riderIcon from "../../../../assets/images/rider-icon.svg";
// import { Marker } from '@vis.gl/react-google-maps';
import { observer } from "mobx-react-lite";
import styles from './riderMarkers.module.scss';
import { Location, useAppState } from "../../../../states/app-state";
import { AdvancedMarker } from "@vis.gl/react-google-maps";

const RiderMarkers: React.FC = observer(() => {

    const appState = useAppState();
    const selectedOrder = appState.selectedOrder;
    const time = selectedOrder?.rider?.path?.time;
    return (
        <>
            {/* <Marker
                icon={{
                    url: riderIcon,
                    // anchor: new google.maps.Point(16, 32),
                    scaledSize: new google.maps.Size(32, 32)
                }}
                position={selectedOrder?.rider.location as Location}
            /> */}
            <AdvancedMarker
                position={selectedOrder?.rider.location as Location}
                style={{
                    transform: "translate(0%, 0%)",
                }}
            >
                <div className={styles.rider_marker} >
                    {/* time text box */}
                    {
                        time &&
                        <div className={styles.text_box}>
                            <p>{time?.split(' ')[0]} <span>{time?.split(' ')[1]}</span></p>
                            <div className={styles.polygon}>
                                <img src='/polygon-white.svg' alt="" width={29} height={57} />
                            </div>
                        </div>
                    }
                    {/* animated icon */}
                    <div>
                        <img className={styles.pulse_orange} src={riderIcon} alt="rider" width={32} height={32} />
                    </div>
                </div>
            </AdvancedMarker>
        </>
    )
})
export default RiderMarkers